import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WidgetDamageStorageService } from "./service/widget-warehouse-inventory-audit-accuracy.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "widget-warehouse-inventory-audit-accuracy",
  templateUrl: "./widget-warehouse-inventory-audit-accuracy.component.html",
  styleUrls: ["./widget-warehouse-inventory-audit-accuracy.component.scss"],
  providers: [WidgetDamageStorageService]
})
export class WidgetInventoryAuditAccuracyComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions;

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetDamageStorageService
  ) { }

  ngAfterViewInit() {
    this.getDamageSortage();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getDamageSortage();
    }
  }

  ngOnInit() {
    this.translateService.get("WAREHOUSE.DAMAGE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getDamageSortage() {
    const params = {};
    this.dataService
      .getDamageSortage(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(chartData => {
        this.chartOptions = this.dataService.createChart(
          chartData,
          this.OPTIONS
        );
      });
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
